var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_22",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.88965H22.4725V23.3907H2V3.88965Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5L9.5 5L19.5 5.5L22 10.5L19 18L12.5 22.5L5 17L2.5 10.5L5.5 5.5Z",
    fill: "#795F60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82396 13.0128C5.22596 17.3748 10.765 20.9018 12.237 21.7748C13.714 20.8928 19.293 17.3268 20.65 13.0168C21.541 10.2308 20.714 6.70177 17.428 5.64277C15.836 5.13177 13.979 5.44277 12.697 6.43477C12.429 6.64077 12.057 6.64477 11.787 6.44077C10.429 5.41977 8.65496 5.12077 7.03796 5.64277C3.75696 6.70077 2.93296 10.2298 3.82396 13.0128ZM12.238 23.3908C12.114 23.3908 11.991 23.3608 11.879 23.2998C11.566 23.1288 4.19296 19.0648 2.39596 13.4708C2.39496 13.4708 2.39496 13.4698 2.39496 13.4698C1.26696 9.94777 2.52296 5.52177 6.57796 4.21477C8.48196 3.59877 10.557 3.86977 12.235 4.92877C13.861 3.90077 16.021 3.61677 17.887 4.21477C21.946 5.52377 23.206 9.94877 22.079 13.4698C20.34 18.9998 12.913 23.1248 12.598 23.2978C12.486 23.3598 12.362 23.3908 12.238 23.3908Z",
    fill: "#8E8EA9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1537 11.5147C17.7667 11.5147 17.4387 11.2177 17.4067 10.8257C17.3407 10.0037 16.7907 9.30967 16.0077 9.05667C15.6127 8.92867 15.3967 8.50567 15.5237 8.11267C15.6527 7.71867 16.0717 7.50467 16.4677 7.62867C17.8307 8.06967 18.7857 9.27667 18.9027 10.7037C18.9357 11.1167 18.6287 11.4787 18.2157 11.5117C18.1947 11.5137 18.1747 11.5147 18.1537 11.5147Z",
    fill: "#8E8EA9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heartFilled.09718d8b7b6f0473d9fbba4d2ab0da96.svg";
export { ForwardRef as ReactComponent };